import { render, staticRenderFns } from "./ProgressBarStep.vue?vue&type=template&id=4bc4e477&"
import script from "./ProgressBarStep.vue?vue&type=script&lang=js&"
export * from "./ProgressBarStep.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBarStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports